/** @format */

import {LoadMoreContextual} from 'frontier/components/search/load_more';
import withPaymentsHandler from './with_payments_handler';
import {CartRelatedOrders} from './cart_related_orders';
import {Currency, Loading} from 'frontier-utilities';
import React, {useContext, useEffect} from 'react';
import {PayInvoice} from './invoice/pay_invoice';
import {useTableSort} from './use_table_sort';
import {SearchContext} from 'frontier-search';
import {Link} from 'react-router-dom';

export default withPaymentsHandler(function (props) {
    const searchCtx = useContext(SearchContext);

    const {sortedData, sortColumn, sortOrder, toggleSort} = useTableSort(searchCtx.listItems);

    useEffect(() => {
        searchCtx.onSearch({});
    }, []);

    return (
        <div className={'all-invoices-09ka'}>
            <PayInvoice {...props} />
            <div className="invoices-09ka__responsive-table mb-4">
                <table cellSpacing="0" width="100%" className="all-invoices-09ka__table">
                    <thead>
                        <tr>
                            <th>
                                <div
                                    className="d-flex align-items-center justify-content-center gap-2"
                                    onClick={() => toggleSort('invoiceId')}>
                                    <h5 className="m-0">Invoice #</h5>
                                    <i
                                        style={{fontSize: '12px'}}
                                        className={`fa ${
                                            sortColumn === 'invoiceId'
                                                ? sortOrder === 'asc'
                                                    ? 'fa-caret-up'
                                                    : 'fa-caret-down'
                                                : 'fa-filter'
                                        }`}></i>
                                </div>
                            </th>
                            <th>
                                <h5 className="m-0">Related Order #</h5>
                            </th>
                            <th>
                                <h5 className="m-0">Placed</h5>
                            </th>
                            <th>
                                <h5 className="m-0">Shipped</h5>
                            </th>
                            <th>
                                <div
                                    className="d-flex align-items-center justify-content-center gap-2"
                                    onClick={() => toggleSort('paid')}>
                                    <h5 className="m-0">Paid</h5>
                                    <i
                                        style={{fontSize: '12px'}}
                                        className={`fa ${
                                            sortColumn === 'paid'
                                                ? sortOrder === 'asc'
                                                    ? 'fa-caret-up'
                                                    : 'fa-caret-down'
                                                : 'fa-filter'
                                        }`}></i>
                                </div>
                            </th>
                            <th>
                                <div
                                    className="d-flex align-items-center justify-content-cente gap-2"
                                    onClick={() => toggleSort('amount')}>
                                    <h5 className="m-0">Amount</h5>
                                    <i
                                        style={{fontSize: '12px'}}
                                        className={`fa ${
                                            sortColumn === 'amount'
                                                ? sortOrder === 'asc'
                                                    ? 'fa-caret-up'
                                                    : 'fa-caret-down'
                                                : 'fa-filter'
                                        }`}></i>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedData.map((cart, i) => {
                            return (
                                <tr key={`${cart.id}`}>
                                    <td className="action-link-cell">
                                        <div>
                                            <i className={'fa fa-eye'}></i>
                                            <u>
                                                <Link to={`/account/charges/index/${cart.id}`}>
                                                    {cart.id}
                                                </Link>
                                            </u>
                                        </div>
                                    </td>
                                    <td>
                                        <CartRelatedOrders
                                            orders={cart.orders}
                                            poNumber={cart.po_number}
                                        />
                                    </td>
                                    <td>
                                        <p>{cart.created_time_formatted}</p>
                                    </td>
                                    <td>
                                        <p>{cart.shipped_time_formatted ?? 'Not Shipped'}</p>
                                    </td>
                                    <td>
                                        <p>{cart.paid_time_formatted ?? 'Unpaid'}</p>
                                    </td>
                                    <td>
                                        <div>
                                            <Currency
                                                value={cart.total}
                                                style={{fontSize: 'unset'}}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>

            {searchCtx.isLoading && <Loading message="Loading Invoices..." />}
            <LoadMoreContextual />
        </div>
    );
});
